import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomDateInput from 'components/common/CustomDateInput';
import ErrorBoundary from 'components/common/ErrorBoundary';
import FalconCloseButton from 'components/common/FalconCloseButton';
import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Card, CloseButton, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import FeedCardInfiniteScroll from 'akasia-components/cliente/orden/comentarios/FeedCardInfiniteScroll';
import FeedProvider from 'akasia-components/cliente/orden/comentarios/FeedProvider';
import ModalClienteGanado from './ModalClienteGanado';

// Importar hooks personalizados
import {
    useLeadActions,
    useLeadAssignment,
    useLeadComments,
    useLeadDetails,
    useLeadEvents,
    useLeadNotifications,
    useLeadStage,
    useLeadTags,
    useLeadVinculation
} from './componentes-modal-seguimiento-lead/hooks';

// Importar componentes personalizados
import {
    LeadBasicInfo,
    LeadEvents,
    LeadLinked,
    LeadSourceSection,
    LeadStageAndBudget,
    LeadStatusInfo,
    LeadTags
} from './componentes-modal-seguimiento-lead/components';


const ModalSeguimientoLead = ({
    showModal,
    setShowModal,
    contactos,
    setContactos,
    lista3LeadsLiberados,
    setLista3LeadsLiberados,
    listaEventos,
    setListaEventos,
    setProximoEvento,
    proximoEvento,
    listaEventosPasados,
    setListaEventosPasados,
    listaEventosHoy,
    setListaEventosHoy,
    listaEventosFuturos,
    setListaEventosFuturos,
    listaLeadsLiberados,
    setListaLeadsLiberados,
    mostrarLeads,
    Filter_Tags,
    filtroEventosVencidos,
    idLead,
    setIdLead,
    leadsVinculados,
    setLeadsVinculados
}) => {

    const { token, setToken, idUsuario } = useToken();

    // Hook de notificaciones (debe estar primero ya que otros hooks lo usan)
    const { crearObjAction, guardarNotificacion } = useLeadNotifications();

    // Hook de detalles del lead
    const {
        cargandoModal,
        procesandoModal,
        detallesLead,
        setDetallesLead,
        eventosActivos,
        setEventosActivos,
        listaJsonLeadsVinculados,
        setListaJsonLeadsVinculados,
        tags,
        catEtapas,
        ObtenerDatosLead
        // vendedor ya no se usa en el componente principal
    } = useLeadDetails(idLead, showModal, setContactos, contactos);

    // Estados para modales
    const [showEtapaClienteGanadoModal, setShowEtapaClienteGanadoModal] = useState(false);
    const [vNombreEtapa, setvNombreEtapa] = useState(null);
    const [showModalLiberarLeads, setShowModalLiberarLeads] = useState(false);
    const [showModalAsignarmeLeadsVinculados, setShowModalAsignarmeLeadsVinculados] = useState(false);
    const [showModalComentarioCambioVendedor, setShowModalComentarioCambioVendedor] = useState(false);
    const [showEtapaNoInteresadoModal, setShowEtapaNoInteresadoModal] = useState(false);

    // Detectar modo oscuro de forma robusta
    const [isDarkTheme, setIsDarkTheme] = useState(false);
    useEffect(() => {
        const detect = () => {
            try {
                const html = document.documentElement;
                const body = document.body;
                const htmlBs = html.getAttribute('data-bs-theme');
                const htmlData = html.getAttribute('data-theme');
                const prefers = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
                const bodyDark = body.classList.contains('dark') || body.classList.contains('dark-mode') || html.classList.contains('dark');
                setIsDarkTheme(htmlBs === 'dark' || htmlData === 'dark' || bodyDark || prefers);
            } catch (e) {
                setIsDarkTheme(false);
            }
        };
        detect();
        const mql = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');
        if (mql && mql.addEventListener) mql.addEventListener('change', detect);
        else if (mql && mql.addListener) mql.addListener(detect);
        const obs = new MutationObserver(detect);
        try {
            obs.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme', 'data-theme', 'class'] });
            obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        } catch (e) {
            // Registrar error en consola para evitar bloque vacío
            console.error('Error observing DOM mutations for theme detection', e);
        }
        return () => {
            try {
                obs.disconnect();
            } catch (e) {
                console.error('Error disconnecting MutationObserver for theme detection', e);
            }
            if (mql && mql.removeEventListener) mql.removeEventListener('change', detect);
            else if (mql && mql.removeListener) mql.removeListener(detect);
        };
    }, []);

    // Estados para campos editables
    const [Modal_NombreLead, setModal_NombreLead] = useState("");
    const [Modal_GiroComercial, setModal_GiroComercial] = useState("");
    const [Modal_Correo, setModal_Correo] = useState("");
    const [Modal_PropuestaEconomica, setModal_PropuestaEconomica] = useState(0);
    const [Modal_Moneda, setModal_Moneda] = useState("");

    // Hook de comentarios
    const {
        comentarios,
        setComentarios,
        comentario,
        setComentario,
        procesandoComentario,
        cargandoComentarios,
        hayMasComentarios,
        GuardarComentario,
        obtenerComentarios,
        submitComment
    } = useLeadComments(detallesLead, setDetallesLead, contactos, setContactos);

    // Hook de acciones del lead
    const {
        editarNombreLead,
        setEditarNombreLead,
        editarGiroComercial,
        setEditarGiroComercial,
        editarCorreo,
        setEditarCorreo,
        editarPropuestaEconomica,
        setEditarPropuestaEconomica,
        actualizarNombreLead: actualizarNombreLeadHook,
        actualizarGiroComercial: actualizarGiroComercialHook,
        actualizarCorreo: actualizarCorreoHook,
        actualizarPropuestaEconomica: actualizarPropuestaEconomicaHook,
        ActualizarFuente
    } = useLeadActions(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrapper functions para actualizaciones con estados locales
    const actualizarNombreLead = () => actualizarNombreLeadHook(Modal_NombreLead);
    const actualizarGiroComercial = () => actualizarGiroComercialHook(Modal_GiroComercial);
    const actualizarCorreo = () => actualizarCorreoHook(Modal_Correo);
    const actualizarPropuestaEconomica = () => actualizarPropuestaEconomicaHook(Modal_PropuestaEconomica, Modal_Moneda);

    // Hook de eventos
    const {
        showAgregarEvento,
        setShowAgregarEvento,
        editarEvento,
        setEditarEvento,
        habilitarBtnEvent,
        setHabilitarBtnEvent,
        habilitarBtnTerminarEvento,
        showWarningEventoRepetido,
        setShowWarningEventoRepetido,
        eventosMismaHora,
        formDataEvent,
        setFormDataEvent,
        handleChange,
        ValidarEventoRepetido: ValidarEventoRepetidoHook,
        RegistrarEvento: RegistrarEventoHook,
        TerminarEvento: TerminarEventoHook
    } = useLeadEvents(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrapper para RegistrarEvento que actualiza listas adicionales
    const RegistrarEvento = async (formData) => {
        console.log('🔵 [DEBUG] formData enviado:', formData);

        const eventoCreado = await RegistrarEventoHook(formData);

        console.log('🟢 [DEBUG] eventoCreado retornado del hook:', eventoCreado);

        if (eventoCreado) {
            console.log('🟣 [DEBUG] editarEvento:', editarEvento);

            // Actualizar eventosActivos
            if (editarEvento === false) {
                // Agregar nuevo evento a eventosActivos
                const nuevosEventosActivos = [eventoCreado, ...eventosActivos];
                console.log('🟠 [DEBUG] Nuevo array eventosActivos:', nuevosEventosActivos);
                setEventosActivos(nuevosEventosActivos);
            } else {
                // Actualizar evento existente en eventosActivos
                const currentEventIndex = eventosActivos.findIndex((e) => e.idLeadEvento === eventoCreado.idLeadEvento);
                console.log('🔵 [DEBUG] Index del evento a actualizar:', currentEventIndex);
                if (currentEventIndex >= 0) {
                    const newEventosActivos = [...eventosActivos];
                    newEventosActivos[currentEventIndex] = eventoCreado;
                    console.log('🟠 [DEBUG] eventosActivos actualizados:', newEventosActivos);
                    setEventosActivos(newEventosActivos);
                }
            }

            // Actualizar otras listas de eventos
            if (listaEventos !== null && listaEventos !== undefined) {
                if (editarEvento === false) {
                    setListaEventos([eventoCreado, ...listaEventos]);
                } else {
                    const currentEventIndex = listaEventos.findIndex((le) => le.idLeadEvento === eventoCreado.idLeadEvento);
                    if (currentEventIndex >= 0) {
                        const newListaEventos = [...listaEventos];
                        newListaEventos[currentEventIndex] = eventoCreado;
                        setListaEventos(newListaEventos);
                    }
                }
            }

            if (proximoEvento !== null && proximoEvento !== undefined && editarEvento === false) {
                setProximoEvento([eventoCreado, ...proximoEvento]);
            }

            console.log('✅ [DEBUG] Evento procesado completamente');
            return eventoCreado;
        } else {
            console.error('❌ [DEBUG] eventoCreado es null o undefined');
            return null;
        }
    };

    // Wrapper para ValidarEventoRepetido que usa el RegistrarEvento wrapper del modal
    const ValidarEventoRepetido = (formData) => ValidarEventoRepetidoHook(formData, RegistrarEvento);

    // Wrapper para TerminarEvento
    const TerminarEvento = (idLeadEvento, resultadoEvento) => {
        const listasEventos = {
            proximoEvento,
            setProximoEvento,
            listaEventos,
            setListaEventos,
            listaEventosPasados,
            setListaEventosPasados,
            listaEventosHoy,
            setListaEventosHoy,
            listaEventosFuturos,
            setListaEventosFuturos
        };
        return TerminarEventoHook(idLeadEvento, resultadoEvento, eventosActivos, setEventosActivos, listasEventos);
    };

    const editarEventos = () => {
        setEditarEvento(true);
        setFormDataEvent({
            ...formDataEvent,
            vTituloEvento: eventosActivos[0].vTituloEvento,
            vDescripcionEvento: eventosActivos[0].vDescripcionEvento,
            dFechaEvento: new Date(eventosActivos[0].dFechaEvento),
            idLeadEvento: eventosActivos[0].idLeadEvento
        });
        setShowAgregarEvento(true);
    };

    // Hook de etapas
    const {
        editarEtapaModal,
        setEditarEtapaModal,
        motivoNoInteresado,
        setMotivoNoInteresado,
        habilitarBtnGuardar,
        CambiarEtapa: CambiarEtapaHook,
        etapaNoInteresado: etapaNoInteresadoHook
    } = useLeadStage(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrappers para gestión de etapas
    const CambiarEtapa = (event) => CambiarEtapaHook(
        event,
        setShowEtapaNoInteresadoModal,
        setShowEtapaClienteGanadoModal,
        setIdLead,
        setvNombreEtapa,
        setEditarEtapaModal,
        leadsVinculados
    );

    const etapaNoInteresado = (idLeadParam) => etapaNoInteresadoHook(
        idLeadParam,
        setShowEtapaNoInteresadoModal,
        setEditarEtapaModal,
        leadsVinculados
    );

    // Hook de asignación de vendedores
    const {
        habilitarBtnLiberarLead,
        habilitarBtnContinuarLiberarLead,
        habilitarBtnAsignarLead,
        habilitarBtnGuardarComentario,
        comentarioCambioVendedor,
        setComentarioCambioVendedor,
        liberarLead: liberarLeadHook,
        cambiarVendedorLead: cambiarVendedorLeadHook
    } = useLeadAssignment(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        listaJsonLeadsVinculados,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrappers para asignación
    const liberarLead = () => liberarLeadHook(setShowModalLiberarLeads, idLead);
    const cambiarVendedorLead = () => cambiarVendedorLeadHook(
        setShowModalComentarioCambioVendedor,
        listaLeadsLiberados,
        setListaLeadsLiberados,
        lista3LeadsLiberados,
        mostrarLeads,
        Filter_Tags,
        filtroEventosVencidos
    );

    // Hook de tags
    const {
        Modal_BitAddTag,
        setModal_BitAddTag,
        Modal_JsonTags,
        setModal_JsonTags,
        Modal_valueTagSelected,
        setModal_valueTagSelected,
        TagsForModalDDL,
        SetTagsForModalDDL,
        actualizarJsonTags: actualizarJsonTagsHook
    } = useLeadTags(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        lista3LeadsLiberados,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrapper para actualizarJsonTags
    const actualizarJsonTags = (updatedTags, objDDLTag) => actualizarJsonTagsHook(updatedTags, objDDLTag, tags);

    // Hook de vinculación
    const {
        habilitarVinculacion,
        setHabilitarVinculacion,
        idLeadVincular,
        setIdLeadVincular,
        procesandoVincular,
        procesandoDesvincular,
        procesandoDesvincularLeadCliente,
        vincularLead: vincularLeadHook,
        desvincularLead: desvincularLeadHook,
        desvincularLeadCliente: desvincularLeadClienteHook
    } = useLeadVinculation(
        detallesLead,
        setDetallesLead,
        contactos,
        setContactos,
        GuardarComentario,
        guardarNotificacion,
        crearObjAction
    );

    // Wrappers para vinculación
    const vincularLead = () => vincularLeadHook(leadsVinculados, setLeadsVinculados, setListaJsonLeadsVinculados);
    const desvincularLead = (idLeadDesvincular) => desvincularLeadHook(idLeadDesvincular, leadsVinculados, setLeadsVinculados, setListaJsonLeadsVinculados);
    const desvincularLeadCliente = () => desvincularLeadClienteHook(listaJsonLeadsVinculados, leadsVinculados, setLeadsVinculados, obtenerComentarios);

    // Sincronizar estados locales con detallesLead
    useEffect(() => {
        if (detallesLead && detallesLead.idLead) {
            setModal_NombreLead(detallesLead.vNombreLead || "");
            setModal_GiroComercial(detallesLead.vGiroComercial || "");
            setModal_Correo(detallesLead.vCorreo || "");
            setModal_PropuestaEconomica(detallesLead.dPropuestaEconomica || 0);
            setModal_Moneda(detallesLead.vMoneda || "");

            if (detallesLead.vJsonTags) {
                setModal_JsonTags(JSON.parse(detallesLead.vJsonTags));
            }
        }
    }, [detallesLead]);

    // Sincronizar TagsForModalDDL cuando cambian tags o Modal_JsonTags
    useEffect(() => {
        if (tags.length > 0 && Modal_JsonTags.length > 0) {
            const TagsToSelect_Copy = tags.filter(tag => {
                const matched = Modal_JsonTags.filter(tl => tl.idLeadTag === tag.idLeadTag);
                return !matched.length;
            });
            SetTagsForModalDDL(TagsToSelect_Copy);
        } else if (tags.length > 0) {
            SetTagsForModalDDL(tags);
        }
    }, [tags, Modal_JsonTags]);

    const closeModalLead = () => {
        setShowModal(false);
        setEditarEtapaModal(false);
        setEditarGiroComercial(false);
        setEditarPropuestaEconomica(false);
        setHabilitarVinculacion(0);
        setModal_JsonTags([]);
        setModal_valueTagSelected(-1);
        setModal_BitAddTag(false);
        setModal_Moneda("");
        setComentario("");
        setComentarios([]);
        setIdLeadVincular("");
        setIdLead(0);
    };

    return (
        <>
            {showModal && (
                <Modal
                    show={showModal}
                    onHide={closeModalLead}
                    size="lg"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    id={"modalSeguimientoLead"}
                >
                    <Modal.Header>
                        <Modal.Title>
                            <LeadStatusInfo
                                detallesLead={detallesLead}
                                cargandoModal={cargandoModal}
                            />
                        </Modal.Title>
                        <FalconCloseButton
                            className="btn btn-circle btn-sm transition-base p-0"
                            id={"cerrarModal"}
                            onClick={closeModalLead}
                        />
                    </Modal.Header>

                    <Modal.Body>
                        <Row>
                            {/* Sección de cliente y acciones */}
                            {/* Cliente vinculado - Lado izquierdo con más espacio */}
                            <Col xs={12} md={8} lg={8} className="mb-2 mb-md-0">
                                {detallesLead.idClienteAkasia == null || detallesLead.idClienteAkasia == '' ? (
                                    <div
                                        className="d-flex align-items-center gap-2 p-2 rounded"
                                        style={{
                                            backgroundColor: isDarkTheme ? '#000000' : '#ffffff',
                                            border: isDarkTheme ? '2px dashed rgba(255,255,255,0.08)' : '2px dashed #dee2e6',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s'
                                        }}
                                        onClick={() => {
                                            setIdLead(detallesLead.idLead);
                                            setShowEtapaClienteGanadoModal(true);
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon="user-plus"
                                            className={isDarkTheme ? 'text-light' : 'text-muted'}
                                            size="lg"
                                        />
                                        <span style={{ color: isDarkTheme ? '#ffffff' : undefined }} className="fs--1 fw-medium">
                                            Click para vincular cliente
                                        </span>
                                    </div>
                                ) : (
                                    <div
                                        className="d-flex align-items-center justify-content-between p-2 rounded"
                                        style={{
                                            backgroundColor: isDarkTheme ? '#000000' : '#ffffff',
                                            border: isDarkTheme ? '1px solid rgba(255,255,255,0.08)' : '1px solid #0d6efd20'
                                        }}
                                    >
                                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                                            <div
                                                className="d-flex align-items-center justify-content-center rounded-circle"
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    backgroundColor: '#0d6efd',
                                                    flexShrink: 0
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon="user-check"
                                                    className="text-white"
                                                    size="sm"
                                                />
                                            </div>
                                            <Link
                                                to={"/clientes/detalle/" + detallesLead.idClienteAkasia}
                                                className="text-decoration-none flex-grow-1"
                                                style={{ minWidth: 0 }}
                                            >
                                                <div className="d-flex flex-column">
                                                    <span style={{ color: isDarkTheme ? '#ffffff' : undefined }} className="fs--2">Cliente vinculado</span>
                                                    <span style={{ color: isDarkTheme ? '#ffffff' : undefined }} className="fw-bold text-primary fs--1 text-truncate">
                                                        {detallesLead.vNombreClienteAkasia == ' '
                                                            ? `Cliente #${detallesLead.idClienteAkasia}`
                                                            : detallesLead.vNombreClienteAkasia
                                                        }
                                                    </span>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="d-flex align-items-center gap-2 ms-2">
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-edit">Editar cliente vinculado</Tooltip>}
                                            >
                                                <button
                                                    className="btn btn-sm btn-link p-1"
                                                    onClick={() => {
                                                        setIdLead(detallesLead.idLead);
                                                        setShowEtapaClienteGanadoModal(true);
                                                    }}
                                                    style={{ lineHeight: 1 }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon="edit"
                                                        className="text-primary"
                                                        size="sm"
                                                    />
                                                </button>
                                            </OverlayTrigger>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-unlink">Desvincular cliente</Tooltip>}
                                            >
                                                <button
                                                    className="btn btn-sm btn-link p-1"
                                                    onClick={() => desvincularLeadCliente()}
                                                    disabled={procesandoDesvincularLeadCliente}
                                                    style={{ lineHeight: 1 }}
                                                >
                                                    <FontAwesomeIcon
                                                        icon="trash"
                                                        className={procesandoDesvincularLeadCliente ? "text-muted" : "text-danger"}
                                                        size="sm"
                                                    />
                                                </button>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                )}
                                <hr></hr>
                            </Col>

                            {/* Botones de acción - Lado derecho */}
                            <Col xs={12} md={4} lg={4}>
                                <div className="d-flex justify-content-md-end">
                                    {(!detallesLead.bRelease && detallesLead.idUsuario == idUsuario)
                                        ? habilitarBtnLiberarLead && (
                                            <button
                                                onClick={() => {
                                                    listaJsonLeadsVinculados.length >= 1
                                                        ? setShowModalLiberarLeads(true)
                                                        : liberarLead();
                                                }}
                                                className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
                                                style={{ minWidth: '160px' }}
                                            >
                                                <FontAwesomeIcon icon="unlock" size="sm" />
                                                <span>Liberar Lead</span>
                                            </button>
                                        )
                                        : detallesLead.bRelease
                                            ? (
                                                <button
                                                    onClick={() => {
                                                        listaJsonLeadsVinculados.length >= 1
                                                            ? setShowModalAsignarmeLeadsVinculados(true)
                                                            : setShowModalComentarioCambioVendedor(true);
                                                    }}
                                                    className="btn btn-success btn-sm d-flex align-items-center gap-2"
                                                    style={{ minWidth: '160px' }}
                                                >
                                                    <FontAwesomeIcon icon="hand-point-up" size="sm" />
                                                    <span>Asignarme Lead</span>
                                                </button>
                                            )
                                            : (detallesLead.iDaysDiffOwner >= 5 || detallesLead.idSource == 0) && habilitarBtnAsignarLead && (
                                                <button
                                                    onClick={() => {
                                                        listaJsonLeadsVinculados.length >= 1
                                                            ? setShowModalAsignarmeLeadsVinculados(true)
                                                            : setShowModalComentarioCambioVendedor(true);
                                                    }}
                                                    className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                                                    style={{ minWidth: '160px' }}
                                                >
                                                    <FontAwesomeIcon icon="hand-point-up" size="sm" />
                                                    <span>Asignarme Lead</span>
                                                </button>
                                            )}
                                </div>

                            </Col>

                        </Row>
                        <Row>
                            <LeadBasicInfo
                                cargandoModal={cargandoModal}
                                detallesLead={detallesLead}
                                editarNombreLead={editarNombreLead}
                                setEditarNombreLead={setEditarNombreLead}
                                Modal_NombreLead={Modal_NombreLead}
                                setModal_NombreLead={setModal_NombreLead}
                                actualizarNombreLead={actualizarNombreLead}
                                editarGiroComercial={editarGiroComercial}
                                setEditarGiroComercial={setEditarGiroComercial}
                                Modal_GiroComercial={Modal_GiroComercial}
                                setModal_GiroComercial={setModal_GiroComercial}
                                actualizarGiroComercial={actualizarGiroComercial}
                                editarCorreo={editarCorreo}
                                setEditarCorreo={setEditarCorreo}
                                Modal_Correo={Modal_Correo}
                                setModal_Correo={setModal_Correo}
                                actualizarCorreo={actualizarCorreo}
                            />

                            <LeadStageAndBudget
                                cargandoModal={cargandoModal}
                                detallesLead={detallesLead}
                                editarEtapaModal={editarEtapaModal}
                                setEditarEtapaModal={setEditarEtapaModal}
                                catEtapas={catEtapas}
                                CambiarEtapa={CambiarEtapa}
                                editarPropuestaEconomica={editarPropuestaEconomica}
                                setEditarPropuestaEconomica={setEditarPropuestaEconomica}
                                Modal_PropuestaEconomica={Modal_PropuestaEconomica}
                                setModal_PropuestaEconomica={setModal_PropuestaEconomica}
                                Modal_Moneda={Modal_Moneda}
                                setModal_Moneda={setModal_Moneda}
                                actualizarPropuestaEconomica={actualizarPropuestaEconomica}
                            />
                        </Row>

                        {cargandoModal ? (
                            <h5>
                                <Spinner className="text-inline mt-3" animation="border" variant="primary" /> Cargando...
                            </h5>
                        ) : (
                            <>
                                {detallesLead && detallesLead.idSource == 0 && (
                                    <LeadSourceSection
                                        detallesLead={detallesLead}
                                        ActualizarFuente={ActualizarFuente}
                                    />
                                )}

                                {detallesLead && detallesLead.idSource > 0 && (
                                    <>
                                        <Row>
                                            <LeadSourceSection
                                                detallesLead={detallesLead}
                                                ActualizarFuente={ActualizarFuente}
                                            />
                                            <hr />
                                            <LeadTags
                                                Modal_BitAddTag={Modal_BitAddTag}
                                                setModal_BitAddTag={setModal_BitAddTag}
                                                Modal_JsonTags={Modal_JsonTags}
                                                Modal_valueTagSelected={Modal_valueTagSelected}
                                                setModal_valueTagSelected={setModal_valueTagSelected}
                                                TagsForModalDDL={TagsForModalDDL}
                                                tags={tags}
                                                actualizarJsonTags={actualizarJsonTags}
                                                cargandoModal={cargandoModal}
                                            />
                                            <hr />
                                            <LeadEvents
                                                eventosActivos={eventosActivos}
                                                detallesLead={detallesLead}
                                                GuardarComentario={GuardarComentario}
                                                TerminarEvento={TerminarEvento}
                                                procesandoModal={procesandoModal}
                                                habilitarBtnTerminarEvento={habilitarBtnTerminarEvento}
                                                editarEventos={editarEventos}
                                                showAgregarEvento={showAgregarEvento}
                                                setShowAgregarEvento={setShowAgregarEvento}
                                                setFormDataEvent={setFormDataEvent}
                                                formDataEvent={formDataEvent}
                                            />

                                            <hr className="d-block d-md-none mt-3" />

                                            <LeadLinked
                                                habilitarVinculacion={habilitarVinculacion}
                                                setHabilitarVinculacion={setHabilitarVinculacion}
                                                idLeadVincular={idLeadVincular}
                                                setIdLeadVincular={setIdLeadVincular}
                                                procesandoVincular={procesandoVincular}
                                                procesandoDesvincular={procesandoDesvincular}
                                                listaJsonLeadsVinculados={listaJsonLeadsVinculados}
                                                vincularLead={vincularLead}
                                                desvincularLead={desvincularLead}
                                                ObtenerDatosLead={ObtenerDatosLead}
                                                cargandoModal={cargandoModal}
                                            />
                                        </Row>
                                    </>
                                )}
                            </>
                        )}
                    </Modal.Body>

                    {detallesLead.idSource > 0 && (
                        <FeedProvider>
                            {cargandoModal ? (
                                <Skeleton />
                            ) : (
                                <ErrorBoundary>
                                    <FeedCardInfiniteScroll
                                        comentarios={comentarios}
                                        setComentarios={setComentarios}
                                        procesandoComentario={procesandoComentario}
                                        setComentario={setComentario}
                                        comentario={comentario}
                                        submitComment={(e) => submitComment(e, lista3LeadsLiberados, setLista3LeadsLiberados, guardarNotificacion)}
                                        idUsuario={Number(idUsuario)}
                                        obtenerComentarios={obtenerComentarios}
                                        hayMasComentarios={hayMasComentarios}
                                        cargandoComentarios={cargandoComentarios}
                                        token={token}
                                        setToken={setToken}
                                    />
                                </ErrorBoundary>
                            )}
                        </FeedProvider>
                    )}

                    <Modal.Footer>
                        {procesandoModal ? (
                            <Button variant="primary" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Procesando...
                            </Button>
                        ) : (
                            <Button onClick={closeModalLead} variant='primary'>
                                Cerrar
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            )}

            {/* Modal para agregar/editar evento */}
            <Modal
                show={showAgregarEvento}
                onHide={() => {
                    setShowAgregarEvento(false);
                    setEditarEvento(false);
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {editarEvento ? (
                            <>Editar Evento de {detallesLead.vNombreLead}</>
                        ) : (
                            <>Crear evento para {detallesLead.vNombreLead}</>
                        )}
                    </Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => {
                            setShowAgregarEvento(false);
                            setEditarEvento(false);
                        }}
                    />
                </Modal.Header>
                <Modal.Body>
                    <>
                        <Row>
                            <Col>
                                <Form.Group controlId="vTituloEvento">
                                    <Form.Label>T&iacute;tulo del evento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="vTituloEvento"
                                        placeholder="Título del evento"
                                        defaultValue={formDataEvent.vTituloEvento}
                                        onBlur={(event) => handleChange('vTituloEvento', event.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group controlId="vDescripcionEvento">
                                    <Form.Label>Descripci&oacute;n del evento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="vDescripcionEvento"
                                        placeholder="Descripci&oacute;n del evento"
                                        defaultValue={formDataEvent.vDescripcionEvento}
                                        onBlur={(event) => handleChange('vDescripcionEvento', event.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <Form.Group controlId="dFechaEvento">
                                    <Form.Label>Fecha del Evento</Form.Label>
                                    <br></br>
                                    <DatePicker
                                        selected={formDataEvent.dFechaEvento}
                                        showTimeSelect
                                        timeIntervals={15}
                                        dateFormat="dd MMM yyyy HH:mm"
                                        onChange={newDate => {
                                            handleChange('dFechaEvento', new Date(newDate));
                                        }}
                                        customInput={
                                            <CustomDateInput
                                                formControlProps={{
                                                    placeholder: 'dd/mm/yyyy hh:mm'
                                                }}
                                            />
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </>
                </Modal.Body>
                <Modal.Footer>
                    {!habilitarBtnEvent ? (
                        <>
                            <Button variant='danger' className="mt-2" disabled>
                                Cancelar
                            </Button>

                            <button disabled className="d-sm-block me-2 btn btn-falcon-default btn-sm">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                &nbsp;Procesando...
                            </button>
                        </>
                    ) : (
                        <>
                            <Button
                                variant='danger'
                                className="mt-2"
                                onClick={() => {
                                    setShowAgregarEvento(false);
                                    setHabilitarBtnEvent(true);
                                    setEditarEvento(false);
                                }}
                            >
                                Cancelar
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                variant='success'
                                className="mt-2"
                                onClick={async () => {
                                    if (editarEvento) {
                                        await RegistrarEvento(formDataEvent);
                                    } else {
                                        await ValidarEventoRepetido(formDataEvent);
                                    }
                                }}
                            >
                                {editarEvento ? <>Guardar</> : <>Registrar evento</>}
                            </Button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modal de advertencia que ya existe un evento a esa hora */}
            <Modal
                show={showWarningEventoRepetido}
                onHide={() => setShowWarningEventoRepetido(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <FontAwesomeIcon
                        className="fa-2x"
                        icon="fa-solid fa-circle-exclamation"
                        style={{ color: "#ffd700" }}
                    />
                    <Modal.Title id="contained-modal-title-vcenter">
                        &nbsp;&nbsp;Evento a la misma hora
                    </Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => setShowWarningEventoRepetido(false)}
                    />
                </Modal.Header>
                <Modal.Body>
                    <>
                        <Row>
                            {eventosMismaHora.map((event, index) => (
                                <Col key={index} className="h-100 mt-2 fs--2 border-end col-6">
                                    <Row>
                                        <Col className="col-12">{"Lead " + event.idLead}</Col>
                                        <Col className="col-12">{event.vNombreLead}</Col>
                                    </Row>

                                    <Row className="justify-content-center">
                                        <Col className="col-5 col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-4 align-item-center align-self-center">
                                            <Card className="m-0 p-0 align-self-center">
                                                <Card.Header
                                                    className="m-0 p-0 text-center text-light fw-bold"
                                                    style={{ backgroundColor: "#e63757", fontSize: "0.8em" }}
                                                >
                                                    {new Date(event.dFechaEvento).getMonth() == 0
                                                        ? "ENE"
                                                        : new Date(event.dFechaEvento).getMonth() == 1
                                                            ? "FEB"
                                                            : new Date(event.dFechaEvento).getMonth() == 2
                                                                ? "MAR"
                                                                : new Date(event.dFechaEvento).getMonth() == 3
                                                                    ? "ABR"
                                                                    : new Date(event.dFechaEvento).getMonth() == 4
                                                                        ? "MAY"
                                                                        : new Date(event.dFechaEvento).getMonth() == 5
                                                                            ? "JUN"
                                                                            : new Date(event.dFechaEvento).getMonth() == 6
                                                                                ? "JUL"
                                                                                : new Date(event.dFechaEvento).getMonth() == 7
                                                                                    ? "AGO"
                                                                                    : new Date(event.dFechaEvento).getMonth() == 8
                                                                                        ? "SEP"
                                                                                        : new Date(event.dFechaEvento).getMonth() == 9
                                                                                            ? "OCT"
                                                                                            : new Date(event.dFechaEvento).getMonth() == 10
                                                                                                ? "NOV"
                                                                                                : new Date(event.dFechaEvento).getMonth() == 11
                                                                                                    ? "DIC"
                                                                                                    : ""}}
                                                </Card.Header>
                                                <Card.Body
                                                    className="m-0 p-0 text-center border border-danger fw-bold text-muted"
                                                    style={{ fontSize: "1.2em" }}
                                                >
                                                    {new Date(event.dFechaEvento).getDate()}
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        <Col className="col-12 col-xxl-9 col-xl-8 col-lg-8 col-md-12 col-sm-12 p-0">
                                            <Row>
                                                <Col className="col-12 text-xxl-start text-xl-start text-lg-start text-md-start text-sm-center col">
                                                    <span className="fw-bold fs--2">
                                                        <span className="">{event.vTituloEvento}</span>
                                                    </span>
                                                </Col>
                                            </Row>
                                        </Col>

                                        <Col className="col-12 mt-1">
                                            <img width={20} src="/img/reloj48.png" alt="Reloj"></img>
                                            {new Date(event.dFechaEvento).toLocaleTimeString('es-mx', {
                                                hour12: true
                                            })}
                                        </Col>
                                    </Row>

                                    <br />
                                </Col>
                            ))}
                        </Row>
                    </>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='danger'
                        className="mt-2"
                        onClick={() => {
                            setShowWarningEventoRepetido(false);
                            setShowAgregarEvento(true);
                        }}
                    >
                        Cancelar
                    </Button>
                    &nbsp;&nbsp;
                    <Button variant='success' className="mt-2" onClick={async () => await RegistrarEvento(formDataEvent)}>
                        Continuar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para escribir un comentario al momento de asignar un nuevo vendedor a un lead */}
            <Modal
                show={showModalComentarioCambioVendedor}
                onHide={() => {
                    setShowModalComentarioCambioVendedor(false);
                    setComentarioCambioVendedor('');
                    setShowModalAsignarmeLeadsVinculados(true);
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Escribe una actualización a este lead para podertelo asignar
                    </Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => {
                            setShowModalComentarioCambioVendedor(false);
                            setComentarioCambioVendedor('');
                            setShowModalAsignarmeLeadsVinculados(true);
                        }}
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(event) => setComentarioCambioVendedor(event.target.value)}
                            value={comentarioCambioVendedor}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='danger'
                        onClick={() => {
                            setShowModalComentarioCambioVendedor(false);
                            setComentarioCambioVendedor('');
                            setShowModalAsignarmeLeadsVinculados(false);
                        }}
                    >
                        Cancelar
                    </Button>

                    {habilitarBtnGuardarComentario ? (
                        <Button variant='success' onClick={() => cambiarVendedorLead()}>
                            Guardar Comentario
                        </Button>
                    ) : (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Procesando...
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modal para confirmar liberar los leads */}
            <Modal
                show={showModalLiberarLeads}
                onHide={() => setShowModalLiberarLeads(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">Leads vinculados</Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => setShowModalLiberarLeads(false)}
                    />
                </Modal.Header>
                <Modal.Body>
                    <h4>
                        Esta acción liberará los leads vinculados a este lead, ¿estas seguro que deseas continuar?
                    </h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='danger' onClick={() => setShowModalLiberarLeads(false)}>
                        Cancelar
                    </Button>

                    {habilitarBtnContinuarLiberarLead ? (
                        <Button variant='success' onClick={() => liberarLead()}>
                            Continuar
                        </Button>
                    ) : (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Procesando...
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* Modal para confirmar asignacion de los leads vinculados */}
            <Modal
                show={showModalAsignarmeLeadsVinculados}
                onHide={() => setShowModalAsignarmeLeadsVinculados(false)}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">Leads vinculados</Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => setShowModalAsignarmeLeadsVinculados(false)}
                    />
                </Modal.Header>
                <Modal.Body>
                    <h4>
                        Esta acción te asignará los leads vinculados de este lead, ¿deseas continuar?
                    </h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='danger' onClick={() => setShowModalAsignarmeLeadsVinculados(false)}>
                        Cancelar
                    </Button>
                    <Button
                        variant='success'
                        onClick={() => {
                            setShowModalComentarioCambioVendedor(true);
                            setShowModalAsignarmeLeadsVinculados(false);
                        }}
                    >
                        Continuar
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal para escoger un cliente y asignarlo a un lead */}
            <ModalClienteGanado
                showEtapaClienteGanadoModal={showEtapaClienteGanadoModal}
                setShowEtapaClienteGanadoModal={setShowEtapaClienteGanadoModal}
                idLead={idLead}
                vNombreEtapa={vNombreEtapa}
                setContactos={setContactos}
                listaJsonLeadsVinculados={listaJsonLeadsVinculados}
                detallesLead={detallesLead}
                GuardarComentario={GuardarComentario}
                setvNombreEtapa={setvNombreEtapa}
                setEditarEtapaModal={setEditarEtapaModal}
                contactos={contactos}
                guardarNotificacion={guardarNotificacion}
                crearObjAction={crearObjAction}
                vendedor={parseInt(detallesLead.idUsuario) || 0}
                setComentarios={setComentarios}
                obtenerComentarios={obtenerComentarios}
                setListaJsonLeadsVinculados={setListaJsonLeadsVinculados}
            />

            {/* Modal para escribir un comentario de porque un cliente no esta interesado */}
            <Modal
                show={showEtapaNoInteresadoModal}
                onHide={() => {
                    setShowEtapaNoInteresadoModal(false);
                    setMotivoNoInteresado('');
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        ¿Por qué no estuvo interesado el Lead?
                    </Modal.Title>
                    <CloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={() => {
                            setShowEtapaNoInteresadoModal(false);
                            setMotivoNoInteresado('');
                        }}
                    />
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Control
                            as="textarea"
                            rows={3}
                            onChange={(event) => setMotivoNoInteresado(event.target.value)}
                            value={motivoNoInteresado}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant='danger'
                        onClick={() => {
                            setShowEtapaNoInteresadoModal(false);
                            setMotivoNoInteresado('');
                        }}
                    >
                        Cancelar
                    </Button>

                    {habilitarBtnGuardar ? (
                        <Button variant='success' onClick={() => etapaNoInteresado(idLead)}>
                            Guardar Motivo
                        </Button>
                    ) : (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            Procesando...
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    );
};

ModalSeguimientoLead.propTypes = {
    showModal: PropTypes.bool,
    setShowModal: PropTypes.func,
    contactos: PropTypes.array,
    setContactos: PropTypes.func,
    lista3LeadsLiberados: PropTypes.array,
    setLista3LeadsLiberados: PropTypes.func,
    listaEventos: PropTypes.array,
    setListaEventos: PropTypes.func,
    setProximoEvento: PropTypes.func,
    proximoEvento: PropTypes.array,
    listaEventosPasados: PropTypes.array,
    setListaEventosPasados: PropTypes.func,
    listaEventosHoy: PropTypes.array,
    setListaEventosHoy: PropTypes.func,
    listaEventosFuturos: PropTypes.array,
    setListaEventosFuturos: PropTypes.func,
    listaLeadsLiberados: PropTypes.array,
    setListaLeadsLiberados: PropTypes.func,
    mostrarLeads: PropTypes.func,
    Filter_Tags: PropTypes.array,
    filtroEventosVencidos: PropTypes.bool,
    idLead: PropTypes.number,
    setIdLead: PropTypes.func,
    leadsVinculados: PropTypes.array,
    setLeadsVinculados: PropTypes.func
};

export default ModalSeguimientoLead;
